import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Component, OnInit,Inject } from '@angular/core';

@Component({
  selector: 'app-confirm-success',
  templateUrl: './confirm-success.component.html',
  styleUrls: ['./confirm-success.component.scss']
})
export class ConfirmSuccessComponent implements OnInit {
  constructor(public dialogRef: MatDialogRef<ConfirmSuccessComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
  }
  onClose(){
    this.dialogRef.close()
  }
}
